import { TOGGLE_TABLE_MAP_VIEW, SELECT_FILTER } from '../actions/constants';

export const defaultState = {
  toggleTableAndMap: true,
  modalItemIndex: 0,
  sortOrderParam: 'distance',
  activeFilter: 'FILTER_PEGELS',
};

export const desktopTableReducer = (state = defaultState, action) => {
  switch (action.type) {
    case SELECT_FILTER: {
      return {
        ...state,
        activeFilter: action.filter,
      };
    }
    case TOGGLE_TABLE_MAP_VIEW: {
      return {
        ...state,
        toggleTableAndMap: !state.toggleTableAndMap,
      };
    }
    default:
      return state;
  }
};
